import { useLocation } from 'react-router-dom';

import { Uid } from 'src/types/dto';

const useReferral = (eventID: Uid) => {
  const ref = new URLSearchParams(useLocation().search).get('referral');
  const referral = JSON.parse(
    localStorage.getItem('uticket:event:referralValues') ?? '{}',
  );

  if (
    (ref && referral === null) ||
    (ref && referral !== null && ref !== referral[eventID])
  ) {
    localStorage.setItem(
      'uticket:event:referralValues',
      JSON.stringify({ ...referral, [eventID]: ref }),
    );
  }

  return referral?.[eventID] ?? '';
};

export default useReferral;
